module.exports = __webpack_public_path__ + "static/media/newLogo.c4a10cfb.svg";